export default __webpack_public_path__ + "static/air_curtain_w.c79ce94103fba540cfb5544ef8a53eb0.png";